import { render } from "./AdminStorage.vue?vue&type=template&id=1fc56a40"
import script from "./AdminStorage.vue?vue&type=script&lang=js"
export * from "./AdminStorage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__